import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import db from '../../db';
import { onSnapshot, collection, query } from "firebase/firestore";
import Aboutusimg from '../../Image/SafiaMedicare.jpg'
import Certificate1 from '../../Image/Certificate1.png'
import Certificate2 from '../../Image/Certificate2.png'
import Certificate3 from '../../Image/Certificate3.png'


const Aboutus = () => {

  const [aboutusData, setAboutusData] = React.useState([])

  useEffect(() => {
    const q = query(collection(db, "Aboutus"))
    const unsub = onSnapshot(q, (querySnapshot) => {
      setAboutusData(querySnapshot.docs.map(d => d.data()))
    });
    return () => unsub();
  }, []);

  // const Certificatedata = [
  //   {
  //     Certificate1image: Certificate1,
  //     Certificateheading: 'Best Dental Clinic of 2020',
  //     Certificatetext: 'Nullam sodales bibendum nulla ut vulputate. Vivamus auctor tincidunt urna, ac molestie lectus imperdiet id. Maecenas nisl massa, mollis sed sem a, finibus dapibus dui. Phasellus rhoncus, quam id molestie efficitur, elit ipsum blandit diam, ac lobortis lectus nibh quis ligula. Ut nunc erat, lobortis vel ultrices aliquet, efficitur id mauris.',
  //   },
  //   {
  //     Certificate1image: Certificate2,
  //     Certificateheading: 'COVID-19 cure participants',
  //     Certificatetext: 'Nullam sodales bibendum nulla ut vulputate. Vivamus auctor tincidunt urna, ac molestie lectus imperdiet id. Maecenas nisl massa, mollis sed sem a, finibus dapibus dui. Phasellus rhoncus, quam id molestie efficitur, elit ipsum blandit diam, ac lobortis lectus nibh quis ligula. Ut nunc erat, lobortis vel ultrices aliquet, efficitur id mauris.',
  //   },
  //   {
  //     Certificate1image: Certificate3,
  //     Certificateheading: 'Best Medicine Delivery 2021',
  //     Certificatetext: 'Nullam sodales bibendum nulla ut vulputate. Vivamus auctor tincidunt urna, ac molestie lectus imperdiet id. Maecenas nisl massa, mollis sed sem a, finibus dapibus dui. Phasellus rhoncus, quam id molestie efficitur, elit ipsum blandit diam, ac lobortis lectus nibh quis ligula. Ut nunc erat, lobortis vel ultrices aliquet, efficitur id mauris.',
  //   },
  // ]

  return (
    <Aboutusmain>
      <AboutImage src={Aboutusimg} alt="About Image" />
      <Aboutparagraph>
      <h1>Welcome to Safia Medicare</h1>

<p>Since 2016, Safia Medicare has been on a mission to provide excellent healthcare to our community. We started small, but with a big heart and a commitment to your well-being.</p>

<p>Our journey is all about growing to meet your needs. From basic care to special treatments, we've expanded our services to make sure you get the best possible care right here.</p>

<p>What makes us different? We believe in treating you, not just your illness. Our friendly team takes the time to understand you and create personalized care plans that fit your unique needs.</p>

<p>We love staying up-to-date with the latest in healthcare. Our facilities are equipped with the newest technology to make sure you receive modern and efficient care.</p>

<p>Thank you for choosing Safia Medicare. We're grateful for your trust and look forward to keeping you healthy and happy for years to come.</p>

<p><em>Your Health, Our Priority. Since 2016.</em></p>
      </Aboutparagraph>
      <Achievementheading>Our Achievements</Achievementheading>
      <Certificate>
        {aboutusData.map((certificate) => (
          <CertificateItem >
            <CertificateImage src={Certificate1} alt='Certificate' />
            <CertificateText>{certificate.Certificatedes}</CertificateText>
          </CertificateItem>
        ))}
      </Certificate>
    </Aboutusmain>
  )
}

export default Aboutus


const Aboutusmain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  text-align: center;
  background: rgba(18, 204, 244, 0.05);
  margin-top: 70px;
`;

const AboutImage = styled.img`
  width: 80%;
  margin: auto;
  max-width: 100%;
  height: auto;
  
`;

const Aboutparagraph = styled.div`
  font-family: Poppins;
  font-size: 20px;
  font-weight: 400;
  line-height: 35px;
  text-align: left;
  color: rgba(6, 33, 38, 0.7);
  width: 80%; 
  margin: auto;
  text-align: left;
  max-width: 776px;
  margin-top: 20px; 
  padding: 20px;
`;
const Achievementheading = styled.div`
  font-family: Poppins;
  font-size: 48px;
  font-weight: 700;
  line-height: 54px;
  text-align: left;
  color: rgba(6, 33, 38, 1);
  width: 100%;
  max-width: 776px;
  margin-top: 20px;
`;
const Certificate = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center; 
  align-items: center; 
  margin-top: 20px;
`;

const CertificateItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const CertificateImage = styled.img`
  width: 25vw;
  height: 362px;
  border-radius: 30px;
`;

const CertificateText = styled.div`
  font-family: Poppins;
  width:25vw;
  font-size: 20px;
  font-weight: 400;
  line-height: 35px;
  text-align: left;
  color: rgba(6, 33, 38, 0.7);
  margin-left: 20px;
`;